const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBloodGlucose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297 297",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "currentColor"
    },
    cx: 148.5,
    cy: 148.5,
    r: 148.5
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M205.655,59.941C172.917,97.978,140.613,142.459,143.5,192.5 c1.571,20.425,6.152,50.034-4.571,69.536l33.102,33.102c69.95-11.138,123.611-71.117,124.934-143.887L205.655,59.941z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#345065"
    },
    d: "M148.5,223.75L148.5,223.75c37.003,0,67-29.997,67-67V82.547 c0-17.167-13.916-31.083-31.083-31.083h-71.834C95.416,51.464,81.5,65.38,81.5,82.547v74.203 C81.5,193.753,111.497,223.75,148.5,223.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 138.929,
    y: 204.607,
    style: {
      fill: "#ECF0F1"
    },
    width: 19.143,
    height: 57.429
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M117.127,147.179h62.746c3.818,0,6.913-3.095,6.913-6.913V77.52c0-3.818-3.095-6.913-6.913-6.913 h-62.746c-3.818,0-6.913,3.095-6.913,6.913v62.746C110.214,144.084,113.309,147.179,117.127,147.179z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC1CF"
    },
    d: "M146.76,157.62h-27.747c-4.859,0-8.798,3.939-8.798,8.798c0,11.8,9.566,21.366,21.366,21.366 h15.179V157.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC1CF"
    },
    d: "M177.988,157.62H150.24v30.165h15.179c11.8,0,21.366-9.566,21.366-21.366 C186.786,161.559,182.847,157.62,177.988,157.62z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M132,115.5c0-9.113,16.5-33,16.5-33s16.5,23.887,16.5,33s-7.387,16.5-16.5,16.5 S132,124.613,132,115.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodGlucose);
export default __webpack_public_path__ + "static/media/BloodGlucose.39a349e8f47220be1bbe406b5689cdbc.svg";
export { ForwardRef as ReactComponent };